<div class="site fadeview iframe-site-view" *ngIf="siteUrl && guid">
    <iframe #site [src]="siteUrl | safe" id="{{ guid }}" width="100%" height="90%" zoom="false"
      frameborder="0"></iframe>
  </div>
